/**
 * The place to store application-wide logic, eg user info, auth session, api URL, etc.
 */

import api from '@/lib/ServerApi'
import {BusyState} from '@/components/Busy/BusySpinner.vue';
import cognitoSession from '@/lib/CognitoSession'

// let userTypes = [
// 	"superuser",    /* all access */
// 	"user",         /* regular user with report type restrictions */
// 	"zone user",    /* regular user with additional zone restrictions */
// 	"admin",        /* regular admin */
// 	"dealer",       /* restricted user (to one dealership and specific report types) */
// 	"dealer admin", /* restricted admin (to one dealership) */
// 	"vendor"        /* same as dealer */
// ];

var typesCanSeeDealerCodes = [
	'admin',
	'user',
	'superuser',
	'zoneUser'
];

var typeCanSeeAdmin = [
	'admin',
	'dealerAdmin',
	'superuser'
];

var typeCanAdmin_Brand = [
	'admin',
	'dealerAdmin',
	'superuser'
]

var typeCanAdmin_Zone = [
	'zoneUser',
	'superuser'
]



function initApp(self, api) {
	self.api = api;
	self.busyState = new BusyState();

	self.cognitoSession.init({
		ClientId : process.env.VUE_APP_COGNITO_CLIENT_ID,
		RedirectUriSignIn : process.env.VUE_APP_LOGIN_URL,
		RedirectUriSignOut : process.env.VUE_APP_LOGOUT_URL,
		AppWebDomain : process.env.VUE_APP_COGNITO_DOMAIN, // Exclude the "https://" part. 
		UserPoolId : process.env.VUE_APP_COGNITO_USER_POOL_ID, 
		IdentityProvider: process.env.VUE_APP_COGNITO_IDENTITY_PROVIDER,
	});

	api.init(self.getApiUrl(), self.busyState);
	api.setSuccessCallback(self.cognitoSession.userWasActive);

	if(sessionStorage.getItem('jwt')) {
		self.initPromise = api.getUserInfo().then(function(response){
			self.user = response;
			self.cognitoSession.startSessionTimers(
				parseInt(process.env.VUE_APP_MAX_SESSION_TIME),
				parseInt(process.env.VUE_APP_MAX_INACTIVE_TIME)
			);
			return response;
		});
	} else {
		self.initPromise = new Promise(function(resolve) {
			resolve({});
		});
	}
}


export default {
	api: null,
	busyState: null,
	initPromise: null,
	cognitoSession: cognitoSession,
	user: {},
	init: function() {
		initApp(this, api)
	},
	allowDealerCodes: function() {
		if(this.user && this.user.userType) {
			return typesCanSeeDealerCodes.indexOf(this.user.userType)>=0;
		}
		else {
			return false;
		}
	},
	allowAdmin: function() {
		if(this.user && this.user.userType) {
			return typeCanSeeAdmin.indexOf(this.user.userType)>=0;
		}
		else {
			return false;
		}
	},
	allowBrandAdmin: function() {
		if(this.user && this.user.userType) {
			return typeCanAdmin_Brand.indexOf(this.user.userType)>=0;
		}
		else {
			return false;
		}
	},
	allowZoneAdmin: function(){
		if(this.user && this.user.userType) {
			return typeCanAdmin_Zone.indexOf(this.user.userType)>=0;
		}
		else {
			return false;
		}
		
	},
	getBusyState: function() {
		return this.busyState;
	},
	created: function(){
		console.log('application controller mounted');
	},
	brand: function(){
		// return getUserInfoFromJwtToken()['custom:brand'];
		return this.user.brand;
		// return "Lexus";
	},
	login: function() {
		this.cognitoSession.login();
	},
	isLoggedIn: function() {
		return this.cognitoSession.isLoggedIn();
	},
	testLoginToken: function() {
		// This will take the SAML response in the URL and
		// test if it's valid. If yes then re-route to "/"
		var curUrl = window.location.href;
		if(curUrl.indexOf('code')>0) {
			this.cognitoSession.testLoginToken(curUrl);
		}
		else {
			return false;
		}
	},
	setSessionExpiredCallback: function(val) {
		this.cognitoSession.setSessionExpiredCallback(val);
	},
	clearTokens: function() {
		this.cognitoSession.clearTokens();
	},

	// This removes all tokens (but does not execute the logout redirect)
	// Returns a promise.
	endSession: function() {
		this.clearTokens();
		return api.serverLogout();
	},

	// This removes all the tokens and runs the logout redirect.
	// Returns a promise.
	logout: function() {
		var self = this;
		return this.endSession().then(function() {
			self.cognitoSession.logout();
		});
	},
	getApiUrl: function() { return process.env.VUE_APP_API_URL },
	getUserFullName: function() {
		var user = this.cognitoSession.getUserInfo();
		return user && user.given_name && user.family_name?
			user.given_name + ' ' + user.family_name :
			this.user.username;
	},
	getUser: function() {
		// return the user fetched from server on login
		return this.user;
	},
	getUserType: function() {
		return this.user.userType;
	},
	getUserTypeString: function() {
		return this.user.userTypeString;
	},
	getDealerCode: function() {
		return this.user.dealerCode;
	},
	getUsersPreferredLanguage: function() {
		return this.user && this.user.language ? this.user.language : 'en';
	},
	updateUserInfo: function(user){
		return api.updateUserInfo(user);
	},
	postLogoutUrl: function() {
		return process.env.VUE_APP_POST_LOGOUT_URL;
	},
	getVersion: function() {
		return process.env.VUE_APP_VERSION || '1';
	},
	getMaxSearchResultsPerLanguage: function() {
		return process.env.VUE_APP_MAX_SEARCH_RESULTS_PER_LANGUAGE ? 
			parseInt(process.env.VUE_APP_MAX_SEARCH_RESULTS_PER_LANGUAGE): 0;
	}
}